import { render, staticRenderFns } from "./UserRegistrationRequiredDialog.vue?vue&type=template&id=a0b33276&"
import script from "./UserRegistrationRequiredDialog.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationRequiredDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports